import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Subscription } from 'rxjs';
// -- components --
import { IntroductionComponent } from '../../introduction/introduction.component';
import { JumpstartGuideComponent } from '../../jumpstart-guide/jumpstart-guide.component';
import { CapacityBuildingComponent } from '../../capacity-building/capacity-building.component';
import { CertificationComponent } from '../../certification/certification.component';
import { FinancingSolutionsComponent } from '../../financing-solutions/financing-solutions.component';
// -- services --
import { TabNavigationService } from '../../services/tab-navigation.service';
import { Jc3Service } from '../../jc3.service';

@Component({
    selector: 'app-mobile-main-tabs',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        IntroductionComponent,
        JumpstartGuideComponent,
        CapacityBuildingComponent,
        CertificationComponent,
        FinancingSolutionsComponent,
    ],
    templateUrl: './mobile-main-tabs.component.html',
    styleUrl: './mobile-main-tabs.component.scss',
})
export class MobileMainTabsComponent {
    private subscription = new Subscription();
    tabsAPIData: any;
    tabs = [
        { title: 'Introduction', slug: 'introduction' },
        { title: 'Jumpstart Guide', slug: 'jumpstart-guide' },
        {
            title: 'Capacity Building, Tools & Resources',
            slug: 'capacity-building',
        },
        { title: 'Certification', slug: 'certification' },
        { title: 'Financing Solutions', slug: 'financing-solutions' },
    ];

    activeTab = 'introduction';
    isDropdownOpen = false;

    constructor(
        private tabNavigationService: TabNavigationService,
        private _jc3Service: Jc3Service
    ) {}

    ngOnInit() {
        this.subscription.add(
            this.tabNavigationService.mainTab$.subscribe((tab) => {
                this.activeTab = tab;
            })
        );
        this.getSwitcherAPIData();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    setActive(tab: string) {
        this.tabNavigationService.navigateToTab(tab);
        this.isDropdownOpen = false; // Close dropdown after selection
    }

    toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    getSwitcherAPIData() {
        this._jc3Service.getSwitcher().subscribe({
            next: (res) => {
                this.tabsAPIData = res.find(
                    (item: { title1?: string }) => item.title1
                );
                this.tabs = this.tabs?.map((tabListItem, index) => {
                    const tabData = { ...tabListItem };
                    tabData.title = this.tabsAPIData[`title${index + 1}`];
                    return tabData;
                });
            },
            error: (error) => {
                console.error('Error fetching WhatsNew data:', error);
            },
        });
    }

    getActiveTabTitle(): string {
        const activeTabObj = this.tabs.find(
            (tab) => tab.slug === this.activeTab
        );
        return activeTabObj ? activeTabObj.title : 'Select Tab';
    }
}
